module.exports = __webpack_public_path__ + "img/Mixpanel.6fbe97fe.svg";